import { render, staticRenderFns } from "./BusGisBrandPowerModal.vue?vue&type=template&id=173e6d7c&"
import script from "./BusGisBrandPowerModal.vue?vue&type=script&lang=js&"
export * from "./BusGisBrandPowerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports